import React, { useMemo } from 'react';
import NotesEditor from '../../../../shared/Notes/NotesEditor';
import { ProfilesTabParamList, useGoBack, useProfilesTabNavigation } from '../../../../../utils/appNavigationNames';
import { useEditNote } from '../../../../../hooks/api/useNotes';
import { RouteProp } from '@react-navigation/native';
import { NoteDestination } from '../../../../shared/Notes/utils/types';
import { useLoadedUser } from '../../../../../hooks/api/useUser';
import { useConfirmBackNavigationOnDirtyForm } from '../../../../shared/FormExitValidation';
import { AnimateLoadedContent } from '../../../../v2BaseComponents/Loader';
import ProfileHeaderContainer from '../../../../v2BaseComponents/ProfileHeaderContainer';

export type EditNoteOwnProps = {};

export type EditNoteProps = EditNoteOwnProps & { route: RouteProp<ProfilesTabParamList, 'edit-note'> };

const EditNote: React.FC<EditNoteProps> = (props) => {
    const goBack = useGoBack();
    const navigator = useProfilesTabNavigation();
    useConfirmBackNavigationOnDirtyForm(navigator);
    const user = useLoadedUser({});
    const { note, isLoadingNote, isUpdatingUserNote, noteEditorProps, key } = useEditNote({
        noteId: props.route.params.noteId,
        onCreationSuccess: () => {
            goBack();
        },
        onUpdateSuccess: () => {
            goBack();
        },
    });

    const noteDestination = useMemo<NoteDestination | null>(
        () =>
            note
                ? ({
                      entityType: note.entityType || 'user',
                      entityId: note.entityId || user.user.userId,
                      medicalProfileId: note.medicalProfileId || undefined,
                  } as NoteDestination)
                : null,
        [note, user],
    );

    const content = (
        <AnimateLoadedContent isLoading={!note || isLoadingNote || !noteDestination || isUpdatingUserNote}>
            {() => (
                <NotesEditor
                    key={key}
                    source="profiles.edit-note-route"
                    defaultTab={props.route.params.defaultTab}
                    onCancel={() => goBack()}
                    isDisabled={isUpdatingUserNote}
                    note={note!}
                    noteDestination={noteDestination!}
                    {...noteEditorProps}
                />
            )}
        </AnimateLoadedContent>
    );

    const profileId = note?.medicalProfileId || null;

    return profileId ? (
        <ProfileHeaderContainer profileId={profileId} bottomBorder omitChatButton>
            {content}
        </ProfileHeaderContainer>
    ) : (
        content
    );
};

export default React.memo(EditNote);
